import script from "./CentralAreaRemunerationSum.vue?vue&type=script&setup=true&lang=ts"
export * from "./CentralAreaRemunerationSum.vue?vue&type=script&setup=true&lang=ts"

import "./CentralAreaRemunerationSum.vue?vue&type=style&index=0&id=02a4ab3d&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a4ab3d"]])

export default __exports__